import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Divider, GridItem, GridRow, MenuItem, ScrollableDrawer, Select, Stack, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../../../hooks/useTranslation';
function BulkEditDrawer({ selectedUsers, showDrawer, onSetShowDrawer, empGLDData, handleBulkGLDSave }) {
    useTranslation();
    const [bulkAssignGLDs, setBulkAssignGLDS] = useState([0, 0, 0, 0, 0]);
    const handleBulkGLDChange = (index, value) => {
        setBulkAssignGLDS((prevValues) => {
            const updatedValues = [...prevValues];
            updatedValues[index] = value;
            return updatedValues;
        });
    };
    const generateGLDItems = (index) => {
        const empGLD = empGLDData[index];
        const menuItems = [];
        if (empGLD.Rows.length === 0) {
            menuItems.push(_jsx(MenuItem, { value: 0, disabled: "true", children: "No values uploaded" }, "0"));
        }
        else {
            menuItems.push(_jsx(MenuItem, { value: 0, style: { fontStyle: 'italic' }, children: "Clear Selected Values" }, "-1"));
            menuItems.push(_jsx(Divider, { light: true }));
            menuItems.push(empGLD.Rows.map((item) => (_jsx(MenuItem, { value: item.PK, children: item.Name }, item.PK))));
        }
        return menuItems;
    };
    const dynamicDropdowns = () => {
        const ddlArray = [];
        for (let i = 0; i < 5; i += 1) {
            const empGLD = empGLDData[i];
            const columnName = `EmployeeGLD${i + 1}`;
            if (empGLD.Label.length > 0) {
                const selectComponent = (_jsx(Select, { id: columnName, style: { width: '100%', minWidth: 'auto' }, label: empGLD.Label, value: bulkAssignGLDs[i], onChange: (e) => handleBulkGLDChange(i, e.target.value), children: generateGLDItems(i) }, columnName));
                ddlArray.push(selectComponent);
            }
        }
        return ddlArray;
    };
    const dropDowns = dynamicDropdowns();
    const handleBulkGLDAction = (action) => {
        if (action === 'cancel') {
            setBulkAssignGLDS([0, 0, 0, 0, 0]);
            onSetShowDrawer(false);
        }
        else if (action === 'save') {
            handleBulkGLDSave(bulkAssignGLDs);
            setBulkAssignGLDS([0, 0, 0, 0, 0]);
            onSetShowDrawer(false);
        }
    };
    return (_jsx(ScrollableDrawer, { open: showDrawer, anchor: "right", sideWidth: 448, openUpdated: onSetShowDrawer, header: $t('Bulk Edit'), footer: _jsxs(GridRow, { justifyContent: "space-between", children: [_jsx(GridItem, { children: _jsx(Button, { color: "primary", variant: "outlined", onClick: () => handleBulkGLDAction('cancel'), children: $t('Cancel') }) }), _jsx(GridItem, { children: _jsx(Button, { onClick: () => handleBulkGLDAction('save'), children: $t('Save') }) })] }), children: _jsxs(Stack, { spacing: 3, direction: "column", alignItems: "stretch", justifyContent: "space-between", children: [_jsxs(Typography, { variant: "subtitle2", children: ["You have selected ", selectedUsers, " users"] }), dropDowns] }) }));
}
export default BulkEditDrawer;
